module.exports = __webpack_public_path__ + "static/media/hisham.7d2f5b34.jpg";